import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBadkamer = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M20.703 7.731h3.393v8.624A10.2 10.2 0 0 1 32 23H12.8a10.2 10.2 0 0 1 7.903-6.645z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M8 10V7h16v3z"
    />
    <circle
      cx={18}
      cy={26}
      r={2}
      fill="#85E3F9"
    />
    <circle
      cx={23}
      cy={26}
      r={2}
      fill="#85E3F9"
    />
    <circle
      cx={28}
      cy={26}
      r={2}
      fill="#85E3F9"
    />
    <circle
      cx={20}
      cy={31}
      r={2}
      fill="#85E3F9"
    />
    <circle
      cx={26}
      cy={31}
      r={2}
      fill="#85E3F9"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBadkamer);

export default ForwardRef;
